import './MarkerSingleOffer.css';
import { GiCannonShot } from 'react-icons/gi';
import { BiWrench } from 'react-icons/bi';
import { GiAncientScrew } from 'react-icons/gi';
import { GiStoneWheel } from 'react-icons/gi';
import { GiBlacksmith } from 'react-icons/gi';
import { CgArrowsShrinkH } from 'react-icons/cg';
import { GiLargePaintBrush } from 'react-icons/gi';
import { RiTeamLine } from 'react-icons/ri';


const MarkerSingleOffer = ({offer, openOfferDetails, mapZoomLevel, autoOpen}) => {

  const displayCuttedTitle = (title) => {
    if (title.length >= 32) {
      return title.slice(0,32) + '...'
    } else if (title.length < 32) {
      return title
    }
  };

  const displaySalary = (min, max, cur) => {
    if (min && max) { return min + '-' + max + ' ' + cur}
    else if (!min || !max) return null
  };

  const showCompanyLogo = (offer) => {
    if (offer.companyLogo) {
      return(<img className={mapZoomLevel < 8 ? 'MapCompanyMiniLogo' : 'MapCompanyMiniLogoZoomed'} src={offer.companyLogo}/>)
    } else if (offer.role === 'Monter') {
      return(<BiWrench className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Spawacz') {
      return (<GiCannonShot className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'CNC') {
      return(<CgArrowsShrinkH className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Ślusarz') {
      return (<GiAncientScrew className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Szlifierz') {
      return(<GiStoneWheel className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Kowal') {
      return(<GiBlacksmith className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Malarz') {
      return(<GiLargePaintBrush className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Brygadzista') {
      return(<RiTeamLine className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    } else if (offer.role === 'Inżynier') {
      return(<CgArrowsShrinkH className={offer.option === 'basic' ? 'MapIcon' : 'MapIconPremium'}/>)
    }
  };

  return (
    <div className='MarkerSingleOfferMainContainer' onClick={() => openOfferDetails(offer)}>
      {showCompanyLogo(offer)}
        <h1 className='MarkerSingleOfferHeader'>{displayCuttedTitle(offer.title)}</h1>
       { mapZoomLevel > 10 ? 
        <>
         <p className='MarkerSingleOfferSalary'>{displaySalary(offer.minSalary, offer.maxSalary, offer.currency)}</p>
         <p>{offer.companyName}</p>
         <p className='MarkerSingleOfferCity'>{offer.city}</p>
       </>
        : null
      }
    </div>
  )
}

export default MarkerSingleOffer;